{
  "InsightsDashboard_Title": "Insights",
  "InsightsDashboard_BusinessFilter": "Business Filter",
  "InsightsDashboard_AllPartitions": "All Sites",
  "InsightsDashboard_CallsReceived": "Calls Received",
  "InsightsDashboard_MissedCalls": "Missed Calls",
  "InsightsDashboard_AverageAnswer": "Average Answer",
  "InsightsDashboard_AverageAbandoned": "Average Abandoned",
  "InsightsDashboard_LongestWait": "Longest Wait",
  "InsightsDashboard_VsLastWeekCurrently": "Currently",
  "InsightsDashboard_PercentVsLastWeek": "**{}%** vs Last Week",
  "InsightsDashboard_VsLastWeek": "**{}** vs Last Week",
  "InsightsDashboard_BusiestDay": "Busiest Day",
  "InsightsDashboard_PeakCalls": "Peak Calls",
  "InsightsDashboard_MostCalledInboundNumber": "Most Called Inbound Number",
  "InsightsDashboard_MostAnsweredCalls": "Most Answered Calls",
  "InsightDashboard_CalledNumber": "Called Number",
  "InsightsDashboard_User": "User",
  "InsightsDashboard_SecondsDisplay": "{}s",
  "InsightsDashboard_Tooltip_TimeLabel": "Time: {}:00",
  "InsightsDashboard_Tooltip_DayLabel": "Day: {}",
  "InsightsDashboard_Tooltip_CallsLabel": "Number of Calls: {}",
  "InsightsDashboard_Tooltip_Stats_0": "Calls Received: {}",
  "InsightsDashboard_Tooltip_Stats_1": "Missed Calls: {}",
  "InsightsDashboard_Tooltip_Stats_2": "Average Answered: {}",
  "InsightsDashboard_Tooltip_Stats_3": "Average Abandoned: {}",
  "InsightsDashboard_Tooltip_Stats_4": "Longest Wait: {}",
  "InsightsDashboard_Tooltip_Stats_WeekCommencing": "Week Commencing: {}",
  "InsightsDashboard_OfLast30Days": "of the Last 30 Days",
  "InsightsDashboard_OverLast30Days": "Over the Last 30 Days",
  "InsightsDashboard_OverLast7Days": "Over the Last 7 Days",
  "InsightsDashboard_ThisWeek": "This Week",
  "InsightsDashboard_LastWeek": "Last Week",
  "InsightsDashboard_PrevWeek": "Prev Week",
  "InsightsDashboard_ErrorState_Message": "We're sorry there has been a problem.\nPlease refresh your browser.\n\n{}",
  "InsightsDashboard_ErrorState_No_TelSys_Or_Partition": "No Telephony Server or Partition selected",
  "InsightsDashboard_Tour_Step_1": "Here you select your business and site",
  "InsightsDashboard_Tour_Step_2": "See touch-point metrics on your business over the last 30 days:\n##?##Busiest Days, allowing you to better schedule resources####Busiest Times, be ready with cover at peak times to not miss calls####?",
  "InsightsDashboard_Tour_Step_3": "Key call performance metrics over the last 30 days:\n##?##Total number of calls received by your business####Calls which were missed####Average answer and abandoned times####Longest time a call was left waiting####?\nClick on the metrics to get week on week comparison and trends.",
  "InsightsDashboard_Tour_Step_4": "Identify your most frequently dialled inbound DDI over the last 7 days, as well as which Users are answering the most calls. This will display the top 10.",
  "InsightsDashboard_Tour_Step_5": "Click here to open the reporting portal",
  "InsightsDashboard_Tour_Step_6": "Click here to open the reporting portal",
  "NAME": "InsightsDashboardLanguage"
}